module.exports = __webpack_public_path__ + "static/media/home3.ee884ca1.jpg";